module.exports = __webpack_public_path__ + "img/aeteradrop.1f71eb1f.png";